export default function FlooringServices() {
  const services = [
    {
      icon: 'ri-layout-grid-line',
      title: 'Hardwood Flooring',
      description: 'Premium hardwood installation, refinishing, and restoration services for timeless elegance and durability'
    },
    {
      icon: 'ri-grid-line',
      title: 'Tile Flooring',
      description: 'Ceramic, porcelain, and natural stone tile installation for kitchens, bathrooms, and high-traffic areas'
    },
    {
      icon: 'ri-stack-line',
      title: 'Luxury Vinyl Plank',
      description: 'Waterproof LVP flooring installation that combines beauty, durability, and easy maintenance'
    },
    {
      icon: 'ri-checkbox-blank-line',
      title: 'Carpet Installation',
      description: 'Comfortable carpet installation for bedrooms and living spaces with professional stretching and seaming'
    },
    {
      icon: 'ri-paint-line',
      title: 'Laminate Flooring',
      description: 'Affordable laminate flooring installation that mimics hardwood with scratch-resistant durability'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Floor Refinishing',
      description: 'Expert hardwood refinishing and restoration to bring new life to worn or damaged floors'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Complete Flooring Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From installation to refinishing, our El Paso flooring contractors provide expert services for every flooring type and budget
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl border border-gray-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 bg-teal-600 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
